export const SET_SEARCHED_LAYER = 'SET_SEARCHED_LAYER';
export const SET_ADDITIONAL_LAYERS_DROPDOWN = 'SET_ADDITIONAL_LAYERS_DROPDOWN';
export const SET_SCROLLING_TO_SEARCHED_LAYER = 'SET_SCROLLING_TO_SEARCHED_LAYER';